const a = {
  id: "TexasCashFive",
  name: "Cash Five",
  style: {
    colorPrimary: "#7dc242"
  }
};
export {
  a as default
};
